<ion-icon
  [name]="iconName()"
  [color]="iconColor()"
  [style.font-size]="iconSize()">
</ion-icon>

<h2>{{ message() | translate }}</h2>

<ion-row class="ion-justify-content-center">
  <ion-col>
    <ion-button
      class="ion-padding"
      expand="block"
      [color]="okButtonColor()"
      (click)="close(true)">
      {{ okButtonText() | translate }}
    </ion-button>
  </ion-col>
  <ion-col>
    <ion-button
      class="ion-padding"
      expand="block"
      [color]="noButtonColor()"
      (click)="close(false)">
      {{ noButtonText() | translate }}
    </ion-button>
  </ion-col>
</ion-row>